require('highlight.js/styles/default.css');

var hljs = require('highlight.js/lib/highlight');
hljs.registerLanguage('javascript', require('highlight.js/lib/languages/javascript'));

module.exports = hljs;
